<div class="feature-card-wrap">
  <div class="feature-card compare-upload-card">
    <p class="credit-cost-notice" *ngIf="detectCreditCost != null || compareCreditCost != null">
      <ng-container *ngIf="detectCreditCost != null">
        Each face detection costs <strong>{{ detectCreditCost }}</strong>
        {{ detectCreditCost === 1 ? 'credit' : 'credits' }}.
      </ng-container>
      {{ ' ' }}
      <ng-container *ngIf="compareCreditCost != null">
        Comparing faces costs <strong>{{ compareCreditCost }}</strong>
        {{ compareCreditCost === 1 ? 'credit' : 'credits' }}.
      </ng-container>
      If the operation fails, credits will be refunded.
    </p>

    <input #fileInput
           type="file"
           multiple
           accept="image/*"
           (change)="onFileSelected($event)"
           style="display: none;">

    <div class="selection-hint">
      <p class="selection-hint-text">
        <i class="bi bi-info-circle" aria-hidden="true"></i>
        For face comparison, please select
        <strong>{{ maxSelectedImages }} images</strong>
        below
      </p>
      <span class="selection-count" *ngIf="hasImages">
        {{ selectedImagesCount }}/{{ maxSelectedImages }} selected
      </span>
    </div>

    <div class="images-grid" data-count="2">
      <ng-container *ngFor="let slot of compareSlots; let i = index">
        <button
          *ngIf="!slot"
          type="button"
          class="image-item empty-frame"
          (click)="onFrameClick(i)"
          [attr.aria-label]="'Upload image ' + (i + 1)">
          <div class="image-preview empty-preview">
            <div class="empty-preview-content">
              <i class="bi bi-image empty-frame-icon" aria-hidden="true"></i>
              <span class="empty-frame-plus"><i class="bi bi-plus-lg"></i></span>
            </div>
          </div>
          <p class="image-name">Image {{ i + 1 }}</p>
        </button>

        <div *ngIf="slot" class="image-item selected">
          <div class="image-preview">
            <img [src]="slot.url" [alt]="slot.name" />
            <div class="image-overlay">
              <button
                class="slot-remove-btn"
                type="button"
                title="Remove from selection"
                (click)="removeSelectedSlot(i)">
                <i class="bi bi-x"></i>
              </button>
            </div>
          </div>
          <p class="image-name" [title]="slot.name">{{ slot.name }}</p>
        </div>
      </ng-container>
    </div>

    <div class="action-buttons" *ngIf="hasImages">
      <button class="action-btn upload-more-btn" type="button" (click)="triggerFileInput()">
        <i class="bi bi-plus-circle"></i>
        <span>Upload More</span>
      </button>
      <button class="action-btn detect-faces-btn" type="button" (click)="detectFaces()">
        <i class="bi bi-arrow-right-circle"></i>
        <span>Detect Faces</span>
      </button>
    </div>
  </div>
</div>

<!-- Upload history panel (replaces separate View Uploads page) -->
<div
  class="history-overlay"
  *ngIf="showHistoryPanel"
  (click)="closeHistoryPanel()">
  <div class="history-panel" (click)="$event.stopPropagation()">
    <div class="history-header">
      <div>
        <h3 class="history-title">Session Uploads</h3>
        <p class="history-subtitle">
          Images from this browser session only. Select up to {{ maxSelectedImages }} for a new compare.
          Saved compares are listed under Compare History below.
        </p>
      </div>
      <button type="button" class="history-close" (click)="closeHistoryPanel()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="history-grid">
      <div
        class="image-item"
        *ngFor="let image of uploadedImages; let i = index"
        [class.selected]="image.selected">
        <div class="image-preview">
          <img [src]="image.url" [alt]="image.name" />
          <div class="image-overlay">
            <input
              type="checkbox"
              class="image-checkbox"
              [checked]="image.selected"
              [disabled]="!image.selected && selectedImagesCount >= maxSelectedImages"
              (change)="toggleImageSelection(i)"
            />
            <div class="action-menu">
              <button class="action-menu-trigger" type="button">
                <i class="bi bi-three-dots-vertical"></i>
              </button>
              <div class="action-menu-dropdown">
                <button class="mirror-btn" type="button" title="Mirror Image" (click)="mirrorImage(i)">
                  <i class="bi bi-arrow-left-right mirror-btn-icon"></i>
                </button>
                <button class="remove-btn" type="button" title="Remove Image" (click)="removeImage(i)">
                  <i class="bi bi-x remove-btn-icon"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <p class="image-name" [title]="image.name">{{ image.name }}</p>
      </div>
    </div>

    <div class="history-footer">
      <span class="selection-count">
        {{ selectedImagesCount }}/{{ maxSelectedImages }} selected
      </span>
      <button type="button" class="action-btn detect-faces-btn" (click)="closeHistoryPanel()">
        Done
      </button>
    </div>
  </div>
</div>

<!-- Server Compare History (reopens detector results UI) -->
<section class="feature-history-section">
  <div class="feature-history-header">
    <h3 class="feature-history-title">Compare History</h3>
    <p class="feature-history-subtitle">
      Saved face comparisons from the server. Click a row to reopen the same results table used after a live compare.
    </p>
  </div>

  <div class="feature-history-loading" *ngIf="loadingCompareHistory">
    <div class="spinner-border" role="status"></div>
    <p>Fetching compare history…</p>
  </div>

  <div class="feature-history-table-wrap" *ngIf="!loadingCompareHistory">
    <table class="feature-history-table">
      <thead>
        <tr>
          <th style="width: 16%">Images</th>
          <th style="width: 14%">Match</th>
          <th style="width: 14%">Probability</th>
          <th style="width: 16%">Date</th>
          <th style="width: 12%">Time</th>
          <th style="width: 28%">Notes</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!compareHistoryRows?.length">
          <td colspan="6" class="feature-history-empty">
            No compares yet. Upload two images and run a compare to see history here.
          </td>
        </tr>
        <tr
          class="table-row"
          *ngFor="let row of compareHistoryRows"
          (click)="openCompareHistoryResult(row)">
          <td>
            <span class="feature-history-thumbs">
              <img
                class="feature-history-thumb"
                [src]="row.image_a_url || 'https://placehold.co/200x200?text=A'"
                [alt]="row.image_a_file_name || 'Image A'"
                (error)="onHistoryImageError($event)"
              />
              <img
                class="feature-history-thumb"
                [src]="row.image_b_url || 'https://placehold.co/200x200?text=B'"
                [alt]="row.image_b_file_name || 'Image B'"
                (error)="onHistoryImageError($event)"
              />
            </span>
          </td>
          <td>
            <span
              class="feature-history-status"
              [class.match-yes]="row.match === true"
              [class.match-no]="row.match === false">
              {{ formatMatch(row.match) }}
            </span>
          </td>
          <td class="feature-history-muted">{{ formatProbability(row.probability) }}</td>
          <td class="feature-history-muted">{{ row.created_on | date: 'MMM d, y' }}</td>
          <td class="feature-history-muted">{{ row.created_on | date: 'HH:mm:ss' }}</td>
          <td class="feature-history-muted" [title]="historyNotesLabel(row)">
            {{ truncateToWords(historyNotesLabel(row)) || '—' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="feature-history-pagination" *ngIf="compareHistoryCount > 0">
    <div class="feature-history-pagination-info">
      Showing {{ compareHistoryPagedStartAndEnd.start }}–{{ compareHistoryPagedStartAndEnd.end }}
      of {{ compareHistoryCount }}
    </div>
    <app-paginator
      [totalItems]="compareHistoryCount"
      [itemsPerPage]="compareHistoryPerPage"
      [currentPage]="compareHistoryCurrentPage"
      (pageChange)="onCompareHistoryPageChange($event)">
    </app-paginator>
  </div>
</section>
